<template>
  <div :class="containerClass">
    <fieldset
        :class="wrapperClass"
        :style="{marginTop: `${dense=== true ? '0' : '8px'}`}"
        @click.stop="emitFocused"
        v-click-outside="emitBlurred"
        @mouseenter="isHovered = true"
        @mouseleave="isHovered = false"
    >
      <div class="input-header">
        <div
            v-if="label.length>0"
            class="wrapper-label v-label"
            :style="`color: ${ isFocused ? '#47bd96' : $vuetify.theme.dark ? 'rgba(255, 255, 255, 0.7)':'#1B6E5A'}; background-color: ${$vuetify.theme.dark ? labelBackground : '#FFFFFF'}`"
        >
          {{ label }}
          <v-tooltip v-if="info.length>0" bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                  v-on="on"
                  size="1em"
                  color="blue"
                  class="input-info"
              >
                fas fa-info-circle
              </v-icon>
            </template>
            <span>{{ info }}</span>
          </v-tooltip>
        </div>
      </div>
      <div class="wrapper-input">
        <slot/>
      </div>
    </fieldset>
  </div>
</template>
<script>
import vuetify from "@/plugins/vuetify";

/**
 * @component InputWrapper
 * UI wrapper/container component to mimic the
 * style and behavior of Vuetify input fields with label
 * when not available in framework's API
 */
export default {
  name: 'InputWrapper',
  props: {
    label: {
      type: String,
      default: 'transparent'
    },
    info: {
      type: String,
      default: ''
    },
    labelBackground: {
      type: String,
      default: 'transparent',
    },
    containerClass: {
      type: String,
      default: '',
    },
    filled: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    }
  },
  data: () => ({
    isFocused: false,
    isHovered: false,
  }),
  computed: {
    wrapperClass() {
      if (this.$vuetify.theme.dark && this.filled && this.isHovered) {
        return 'wrapper-controller dark filled active';
      }
      if (this.$vuetify.theme.dark && this.filled) {
        return 'wrapper-controller dark filled';
      }
      if (!this.$vuetify.theme.dark && this.filled && this.isHovered) {
        return 'wrapper-controller light filled active';
      }
      if (!this.$vuetify.theme.dark && this.filled) {
        return 'wrapper-controller light filled';
      }
      return 'wrapper-controller';
    },
  },
  methods: {
    vuetify() {
      return vuetify
    },
    emitFocused() {
      this.isFocused = true;
      this.$emit('focus');
    },
    emitBlurred() {
      this.isFocused = false;
      this.$emit('blur');
    }
  },
}
</script>

<style scoped lang="scss">
.wrapper-controller {
  position: relative;
  padding: 7px 6px;
  border: 1px solid #47bd96;
  border-radius: 4px;
  margin-top: 8px;
  max-width: 300px;

  &.filled {
    &.dark {
      background-color: rgba(255, 255, 255, 0.05);
    }

    &.light {
      background-color: rgba(0, 0, 0, 0.05);
    }
  }

  &.active {
    &.dark {
      background-color: rgba(255, 255, 255, 0.1);
    }

    &.light {
      background-color: rgba(0, 0, 0, 0.1);
    }
  }

  .wrapper-label {
    position: absolute;
    top: -9px;
    left: 8px;
    right: 0;
    height: 12px;
    line-height: 12px;
    font-size: 12px;
    letter-spacing: normal;
    max-width: fit-content;
    padding: 2px 2px;
    background-color: transparent;
    background-clip: padding-box;
    border-radius: 25%;

    & > .input-info {
      margin-left: 2px;
      margin-bottom: 1px;
    }
  }

  .input-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-items: center;
  }

  .wrapper-input {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: 0;
    padding-top: 0;


    & > .v-input {
      max-width: fit-content;
      margin-top: 0;
      padding-top: 0;
    }
  }
}
</style>